const action = {
	ACTION_UPDATE_USER_INFO : "ACTION_UPDATE_USER_INFO",
	ACTION_UPDATE_USER_EMAIL : "ACTION_UPDATE_USER_EMAIL",
	ACTION_UPDATE_USER_BALANCE : "ACTION_UPDATE_USER_BALANCE",
	ACTION_UPDATE_USER_SESSION : "ACTION_UPDATE_USER_SESSION",
	ACTION_UPDATE_CURRENT_PAGE : "ACTION_UPDATE_CURRENT_PAGE",
	SERVICE_LOGIN_BY_SESSION : "SERVICE_LOGIN_BY_SESSION"
};

export default action;


// WEBPACK FOOTER //
// ./src/helper/action.js